<template lang="pug">
#map.absolute.absolute--fill
</template>

<script>
import mapboxgl from 'mapbox-gl';
import U from 'mapbox-gl-utils';
import { EventBus } from '../EventBus';

const currentSchools = window
    .fetch('schools/schools-2025.json')
    .then((res) => res.json());

export default {
    props: ['boundaryYear'],

    data: () => ({
        relevantEntityCodes: null,
        selectedEntityCode: null,
        selectedDtaType: null,
        selectedSchool: null,
        geocodeResult: null,
    }),
    async mounted() {
        // replace this Mapbox access token with your own
        // mapboxgl.accessToken = 'pk.eyJ1Ijoic3RldmFnZSIsImEiOiJjazNmNGV5enAwMTF1M2tuejhtc2twcXo5In0.mLPrYIYJ2FiFZ3KMqVIj6w';
        const tileHost = window.app.tileHost;
        const maptilerKey = 'FtkDUd27OShqsbpIrKqG';
        const style = `https://api.maptiler.com/maps/basic/style.json?key=${maptilerKey}`;
        const map = new mapboxgl.Map({
            container: 'map',
            center: [145, -37.22],
            zoom: 7,
            minZoom: 7,
            maxZoom: 15,
            dragRotate: false,
            minPitch: 0,
            maxPitch: 0,
            style,
        });
        map.touchZoomRotate.disableRotation();
        map.addControl(
            new mapboxgl.NavigationControl({ showCompass: false }),
            'top-right'
        );
        U.init(map, mapboxgl);
        window.map = map;
        window.app.Map = this;
        map.U.loadImage('geocode-pin', 'darkblue-map-marker.png');
        map.U.loadImage('school-selected', 'school-red.png');
        map.U.loadImage('school-unselected', 'school-grey.png');

        map.U.onLoad(() => {
            map.U.addVector('dta', `${tileHost}/tiles/dta/index.json`);
            map.U.addLine('relevant-dta', 'dta', {
                sourceLayer: 'dta',
                lineColor: 'hsl(0,50%,70%)',
                lineJoin: 'round',
                filter: false,
                visibility: 'none',
            });
            map.U.addLine('selected-dta', 'dta', {
                sourceLayer: 'dta',
                // lineColor: 'hsl(0,80%,50%)',
                lineColor: 'hsl(220,80%,40%)',
                lineWidth: 5,
                filter: false,
            });

            map.U.addGeoJSON(`schools-${this.boundaryYear}`);
            currentSchools.then((data) => {
                map.U.update(`schools-${this.boundaryYear}`, data);
            });
            map.U.addSymbol(
                `schools-${this.boundaryYear}`,
                `schools-${this.boundaryYear}`,
                {
                    /*
                textField: ['get', 'School_Name'],
                textAnchor: 'left',
                // textFont: !window.app.showBasemap ? ['Klokantech Noto Sans Regular'] : ['DIN Offc Pro Regular'],
                textFont: ['DIN Offc Pro Regular'],
                textSize: 12,
                textOffset: [2,0],
                textJustify: 'left',
                // textHaloColor: 'white',
                textHaloColor: 'hsl(80, 11.1%, 94.7%)', // map background
                textHaloWidth: 5,
                // textOptional: true,
                */
                    iconAllowOverlap: true,
                    iconImage: 'school-selected',
                    iconSize: {
                        stops: [
                            [13, 0.4], // 14, 0.3
                            [15, 0.6], // 15, 0.4
                        ],
                    },

                    filter: false,
                }
            );
            map.U.addGeoJSON('geocode-result');
            map.U.addSymbol('geocode-pin', 'geocode-result', {
                iconImage: 'geocode-pin',
                iconSize: {
                    stops: [
                        [11, 0.5],
                        [13, 0.75],
                    ],
                },
                iconAnchor: 'bottom',
            });

            EventBus.$on('select-dta', (result, dtaType) => {
                this.selectedDtaType = dtaType;
                this.selectedEntityCode = result.Entity_Code;
                this.relevantEntityCodes = [this.selectedEntityCode];
                this.$nextTick(() => map.resize());
            });
            EventBus.$on(
                'boundary-results',
                (results) =>
                    (this.relevantEntityCodes = results
                        ? results.map((r) => r.Entity_Code)
                        : [])
            );
            EventBus.$on(
                'geocode-result',
                (result) => (this.geocodeResult = result)
            );
        });
    },
    computed: {
        selectedEntityCodeDtaType() {
            return [this.selectedEntityCode, this.selectedDtaType];
        },
    },
    watch: {
        async selectedEntityCodeDtaType([entityCode, dtaType]) {
            if (!entityCode) {
                window.map.U.setFilter(
                    ['selected-dta', `schools-${this.boundaryYear}`],
                    false
                );
                return;
            }
            const filter = [
                'all',
                ['==', ['get', 'Entity_Code'], entityCode],
                dtaType ? ['==', ['get', 'DTA_Type'], dtaType] : true,
            ];
            window.map.U.setFilter(
                ['selected-dta' /*, `schools-${this.boundaryYear}`*/],
                filter
            );

            this.selectedSchool = (await currentSchools).features.find(
                (s) => s.properties.Entity_Code === entityCode
            );
            const padding =
                Math.min(
                    window.map.getContainer().clientWidth,
                    window.map.getContainer().clientHeight
                ) * 0.35;
            window.map.fitBounds(
                getBbox(this.selectedSchool, this.geocodeResult),
                { padding }
            );
        },
        selectedSchool(school) {
            if (this.schoolMarker) {
                this.schoolMarker.remove();
            }
            if (!school) {
                return;
            }
            const element = document.createElement('div');
            element.innerHTML = school.properties.School_Name;
            element.className = 'school-label';
            this.schoolMarker = new mapboxgl.Marker({ element })
                .setLngLat(school.geometry.coordinates)
                .addTo(window.map);
        },
        async relevantEntityCodes() {
            // window.map.U.setFilter(['relevant-dta'], ['in', ['get', 'Entity_Code'], ['literal', this.relevantEntityCodes]]);
            window.map.U.setFilter(
                [`schools-${this.boundaryYear}`],
                [
                    'in',
                    ['get', 'Entity_Code'],
                    ['literal', this.relevantEntityCodes],
                ]
            );
            if (this.schoolMarkers) {
                this.schoolMarkers.forEach((m) => m.remove());
            }
            const schools = await currentSchools;
            this.schoolMarkers = this.relevantEntityCodes
                .map((entityCode) => {
                    const school = schools.features.find(
                        (s) => s.properties.Entity_Code === entityCode
                    );
                    if (!school) {
                        console.error(
                            `No school point found for school ${entityCode}`
                        );
                        return;
                    }
                    const element = document.createElement('div');
                    element.innerHTML = school.properties.School_Name;
                    element.className = 'school-label';
                    return new mapboxgl.Marker({ element })
                        .setLngLat(school.geometry.coordinates)
                        .addTo(window.map);
                })
                .filter(Boolean);
        },
        geocodeResult(location) {
            window.map.U.setData('geocode-result', location);

            const el = document.createElement('div');
            el.innerHTML = location.properties.label;
            el.className = 'address-label';
            if (this.addressMarker) {
                this.addressMarker.remove();
            }
            this.addressMarker = new mapboxgl.Marker({
                element: el,
            })
                .setLngLat(location.geometry.coordinates)
                .addTo(map);

            window.map.flyTo({
                center: location.geometry.coordinates,
                zoom: 11,
            });
            this.selectedSchool = null;
            this.selectedEntityCode = null;
        },
    },
};

function getBbox(...points) {
    return points.reduce(
        (bbox, point) => [
            Math.min(bbox[0], point.geometry.coordinates[0]),
            Math.min(bbox[1], point.geometry.coordinates[1]),
            Math.max(bbox[2], point.geometry.coordinates[0]),
            Math.max(bbox[3], point.geometry.coordinates[1]),
        ],
        [200, 200, -200, -200]
    );
}

import 'mapbox-gl/dist/mapbox-gl.css';
</script>

<style>
.address-label {
    font-family: 'VIC', 'Avenir', Helvetica, Arial, sans-serif;
    text-align: center;
    background: white;
    max-width: 150px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    padding: 0.5em;
    margin-top: -80px;
}

.school-label {
    font-family: 'VIC', 'Avenir', Helvetica, Arial, sans-serif;
    text-align: center;
    background: white;
    max-width: 150px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    padding: 0.5em;
    margin-top: -40px;
}
</style>
